import HomePage from "./home";
import BackToTop from "./backToTop";

export default function Home() {
  return (
    <>
      <main className="">
        <HomePage />
        <BackToTop />
      </main>
    </>
  );
}
